export const getUserflow = () => window.userflow;

export const trackUserFlowEvent = (eventName: string) => {
    if (getUserflow()) {
        try {
            const eventNameUserFlow = eventName.replace(/\//g, "_");
            getUserflow().track(eventNameUserFlow);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
};
